export const defaultStyles = {
  padding: 'px-6 lg:px-12 xl:px-18 2xl:px-32',
  paddingBig: 'px-6 lg:px-24 xl:px-32 2xl:px-52',
};
